import React, { useState } from 'react';
import { Row, Col, Button } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import TickIcon from 'assests/icons/tick.icon';

import 'react-credit-cards/es/styles-compiled.css';
import 'swiper/swiper.less';

import classNames from 'classnames';
import { usePackage } from 'context/package.context';


const mockList =[];

const mappingList = 
  {9260:"GOLD ABC",
 9261:"STANDART ABC",
 160574:"Mini",
 160577:"Mini",
 160576:"Mini+",
 160580:"Mini+",
 160575:"Mini++",
 160578:"Mini++",
 161175:"Midi",
 161174:"Midi",
 198177:"Midi+",
 198178:"Midi+",
 198179:"Midi++",
 198180:"Midi++",
 198181:"Maxi",
 198182:"Maxi",
 198183:"Maxi+",
 198184:"Maxi+"}
;

const Item = ({ isSelected, item, onSelect, selectable,discount  }) => {
  let myItem = item;
  myItem.name=(mappingList[item.no] ? mappingList[item.no]  : item.name);
  const prize = discount ? discount : item.prize;
  function boxesStatus(temp) {
    if (temp < 450) {
      return 'low';
    } else if (temp > 450 && temp < 1000) {
      return 'medium';
    } else {
      return 'high';
    }
  }
  
  return (
    <div className={classNames("boxes-item "+ boxesStatus(prize), { 'boxes-item--discount' : discount })} >
      <div className={`boxes-item-body ${isSelected ? 'selected' : ''}`}>
        <div className="boxes-item-title">{selectable ? (mappingList[myItem.no] ? mappingList[myItem.no]  : myItem.name)  : myItem.name}</div>
        <div className="boxes-item-horizontal-row" />
        <span className="boxes-item-sms-count">{myItem.credit.toLocaleString('tr-TR')}</span>
        <span className="boxes-item-sms-text">SMS</span>
        { discount ? <span className="boxes-item-sms-discount">{myItem.prize.toLocaleString('tr-TR')} TL</span> : false }
        <div>
          <span className="boxes-item-price-main">
            {prize && prize.toLocaleString('tr-TR') + ' TL'}
          </span>
         
        </div>
        {isSelected && (
          <div className="checkbox">
            <TickIcon className="checkbox-tick" />
          </div>
        )}
      </div>
      {!isSelected && selectable && (
        <div className="boxes-item-footer">
          <Button type="ghost" shape="round" onClick={() => onSelect(myItem)}>
            Seç
          </Button>
        </div>
      )}
    </div>
  );
};

const Boxes = ({ selected, onChangeSelected, list = mockList, title="Paket Seçin", selectable=true }) => {
  const [selectedItem, setSelectedItem] = useState(selected);
  const { setSelectedPackage, discountList } = usePackage();


  
  function onChangeItem(e)
  {
    setSelectedItem(e);
    setSelectedPackage(e);
  }


  return (
    <>
      <Row className="boxes-header">
        <h1 className="section__title">{title}</h1>
      </Row>
      <Row className="boxes">
        <Col span={24}>
          <div className="boxes-list">
            <div className="container">
              <Swiper
                spaceBetween={16}
                slidesPerView="auto"
              >
                {list.sort((a, b) => a.prize > b.prize ? 1 : -1).map((item, index) => (
                  <SwiperSlide  key={'box-item-' + item.no}>
                    <Item selectable={selectable}

                      item={item}
                      discount={  discountList[item.no]}
                      isSelected={selectedItem && selectedItem.no === item.no}
                      onSelect={onChangeItem}
                      key={'box-item-' + item.no}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Boxes;
